
  import { Vue, Component, Prop } from 'vue-property-decorator'
  import moment from 'moment';
  import { bindWechatQrcode,isBindOtherWechat } from '@/apis/myInfo/myInfo';
  import i18n from '@/lang/index';
  import { Dialog, Toast } from 'vant'
  import CommonVue from '@/components/CommonVue/CommonVue';

  //绑定其他微信
  @Component({
    name: 'BindOtherWechatPopup',
    components: {

    },

  })
  export default class BindOtherWechatPopup extends CommonVue {
    private appid:string  = "wx0a889c9e094104e9";
    private qrcode:string = "";
    private show: boolean = false;

    created(){
      if (this.$store.state.userInfo.usertype === '0') {
        isBindOtherWechat({appid:this.appid}).then((res:any)=>{
          this.$emit('bindState',res.bindState);
          if(res.bindState == 111){//111
              bindWechatQrcode({appid:this.appid}).then((res1:any)=>{
                this.qrcode = res1.url;
                this.show   = true;
              });
            }
          });
      }
    }

    handleClose(){
      this.show = false;
    }
  }
  